import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import {
  CollapsedIcon,
  DisclaimerBlock,
  DisclaimerBox,
  DisclaimerDetails,
  DisclaimerIcon,
  DisclaimerSeparator,
  DisclaimerText,
  DisclaimerTitle,
  DisclaimerToggle,
  ExpandedIcon,
} from './RecordingDisclaimer.styles';

interface RecordingDisclaimerProps {
  isExpanded: boolean;
  onToggleExpanded: () => void;
  onOpenCaptureObjectionModal: () => void;
}

export const RecordingDisclaimer = ({
  isExpanded,
  onToggleExpanded,
  onOpenCaptureObjectionModal,
}: RecordingDisclaimerProps) => {
  const { t } = useTranslation();

  return (
    <DisclaimerBox>
      <DisclaimerBlock>
        <DisclaimerToggle onClick={onToggleExpanded} aria-expanded={isExpanded}>
          <DisclaimerIcon />
          <DisclaimerTitle>{t('recording.disclaimer.title')}</DisclaimerTitle>
          {isExpanded ? <ExpandedIcon /> : <CollapsedIcon />}
        </DisclaimerToggle>
        {isExpanded && (
          <DisclaimerDetails>
            <DisclaimerText>{t('recording.disclaimer.text')}</DisclaimerText>
            <Button
              type="button"
              variant="link"
              size="xs"
              className="h-auto p-0 text-destructive"
              onClick={onOpenCaptureObjectionModal}
            >
              {t('recording.disclaimer.captureObjection')}
            </Button>
          </DisclaimerDetails>
        )}
      </DisclaimerBlock>
      <DisclaimerSeparator />
    </DisclaimerBox>
  );
};
